/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does punctuation count as a syllable?`)
};

const es_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿La puntuación cuenta como sílaba?`)
};

const de_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zählt Interpunktion als Silbe?`)
};

const nl_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telt interpunctie als een lettergreep?`)
};

const fr_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ponctuation compte-t-elle comme une syllabe ?`)
};

const it_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La punteggiatura conta come una sillaba?`)
};

const pt_br2_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pontuação conta como sílaba?`)
};

const pt_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pontuação conta como sílaba?`)
};

const ja_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`句読点は音節として数えられますか？`)
};

const zh_syl_haiku_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标点符号会被计为音节吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_faq3_q", locale)
	if (locale === "en") return en_syl_haiku_faq3_q(inputs)
	if (locale === "es") return es_syl_haiku_faq3_q(inputs)
	if (locale === "de") return de_syl_haiku_faq3_q(inputs)
	if (locale === "nl") return nl_syl_haiku_faq3_q(inputs)
	if (locale === "fr") return fr_syl_haiku_faq3_q(inputs)
	if (locale === "it") return it_syl_haiku_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_faq3_q(inputs)
	if (locale === "pt") return pt_syl_haiku_faq3_q(inputs)
	if (locale === "ja") return ja_syl_haiku_faq3_q(inputs)
	return zh_syl_haiku_faq3_q(inputs)
};